export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.idincu.ovey.android';
export const APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/ovey/id483557574';
export const SUPPORT_URL = 'https://support.ovey.io/ko';
